import globals from "@/utils/globals"
import loadScript from "@/utils/load-script"

let recurlyInstance
let paypal
let applePay
let googlePay

export const init = (recurlyKey) => {
  return loadScript("https://js.recurly.com/v4/recurly.js")
    .then(() => {
      recurlyInstance = window.recurly
      recurlyInstance.configure({
        publicKey: recurlyKey || globals.recurlyKey,
        required: ["cvv"]
      })
      recurly.cc.elements = recurlyInstance.Elements()
    })
    .catch((e) => {
      throw new Error(e)
    })
}

const recurly = {
  paypal: {
    init: ({ productName, onSuccess, onError, onCancel }) => {
      paypal = recurlyInstance.PayPal({ display: { displayName: productName } })
      paypal.on("token", onSuccess)
      paypal.on("error", onError)
      if (onCancel) {
        paypal.on("cancel", onCancel)
      }
    },
    submit: () => {
      paypal.start()
    }
  },
  applePay: {
    init: (params, onSuccess, onError, onReady) => {
      applePay = recurlyInstance.ApplePay({
        ...params,
        callbacks: {
          onPaymentAuthorized: onSuccess
        }
      })

      applePay.on("error", onError)
      applePay.ready(onReady)
    },
    submit: () => {
      applePay.begin()
    }
  },
  googlePay: {
    init: (params, onSuccess, onError, onReady) => {
      const environment = globals.googlePayEnvironment
      const googleMerchantId = globals.googleMerchantId

      googlePay = recurlyInstance.GooglePay({
        ...params,
        environment,
        googleMerchantId,
        billingAddressRequired: true,
        callbacks: {
          onPaymentAuthorized: onSuccess
        }
      })
      googlePay.on("error", onError)
      googlePay.ready(onReady)
    }
  },
  cc: {
    submit: (form) =>
      new Promise((resolve, reject) => {
        recurlyInstance.token(recurly.cc.elements, form, (err, token) => {
          if (err) {
            reject(err)
          } else {
            resolve(token)
          }
        })
      }),
    elementStyle: {
      fontFamily: "Montserrat, sans-serif, arial",
      fontSize: "1rem",
      fontColor: "#3E454D",
      background: "#FFFFFF",
      padding: "0",
      placeholder: { color: "#BAC8CE" }
    },
    elements: null
  },
  threeds: {
    challenge: (token, container) =>
      new Promise((resolve, reject) => {
        const risk = recurlyInstance.Risk()
        const threeDSecure = risk.ThreeDSecure({ actionTokenId: token })

        threeDSecure.on("error", reject)
        threeDSecure.on("token", resolve)

        threeDSecure.attach(container)
      })
  }
}

export default recurly
